<div class="ui-g-12">

  <div class="campaigncharts" *ngIf="data != null">
    <div class="ui-g">
      <div class="ui-g-12 ui-md-12 ui-sm-12">
        <h2>{{ translations.valueSegmentDistribution }}</h2>
        <div class="chart-container">
          <chart [options]="valueSegmentDistributionChart.options" (load)="setChartInstance(valueSegmentDistributionChart, $event.context)"></chart>
        </div>
      </div>
    </div>
  </div>

  <div class="campaigncharts" *ngIf="data != null">
    <div class="ui-g">

      <div class="ui-g-12 ui-md-6 ui-sm-12">
        <h2>{{ translations.transactions }}</h2>
        <div class="chart-container">
          <chart [options]="transactionsChart.options" (load)="setChartInstance(transactionsChart, $event.context)"></chart>
        </div>
      </div>

      <div class="ui-g-12 ui-md-6 ui-sm-12">
        <h2>{{ translations.spentAmount }}</h2>
        <div class="chart-container">
          <chart [options]="spentAmountChart.options" (load)="setChartInstance(spentAmountChart, $event.context)"></chart>
        </div>
      </div>

      <div class="ui-g-12 ui-md-6 ui-sm-12">
        <h2>{{ translations.recency }}</h2>
        <div class="chart-container">
          <chart [options]="recencyChart.options" (load)="setChartInstance(recencyChart, $event.context)"></chart>
        </div>
      </div>

      <div class="ui-g-12 ui-md-6 ui-sm-12">
        <h2>{{ translations.spent_per_visit }}</h2>
        <div class="chart-container">
          <chart [options]="spentVisitChart.options" (load)="setChartInstance(spentVisitChart, $event.context)"></chart>
        </div>
      </div>
    </div>
  </div>

</div>





// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-value/customer-value-detail/customer-value-detail.component.html